import { useState, useEffect, useRef } from "react";
import { C } from "../data";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";

export default function Header({ onGoHome, onGoShop, onGoAbout, onGoBoard, transparent = false, navCats, mainMenu, onOpenAuth, onOpenCart, onGoMyPage, eventBanner, eventBannerVisible, onDismissEventBanner }) {
  const { user, profile, signOut } = useAuth();
  const { count } = useCart();
  const [scrolled,    setScrolled]    = useState(false);
  const [shopHover,   setShopHover]   = useState(false);
  const [menuOpen,    setMenuOpen]    = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const shopTimer = useRef(null);
  const userMenuRef = useRef(null);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  useEffect(() => {
    const fn = (e) => { if (userMenuRef.current && !userMenuRef.current.contains(e.target)) setUserMenuOpen(false); };
    document.addEventListener("mousedown", fn);
    return () => document.removeEventListener("mousedown", fn);
  }, []);

  const showBg = scrolled || !transparent;
  const handleShopEnter = () => { clearTimeout(shopTimer.current); setShopHover(true); };
  const handleShopLeave = () => { shopTimer.current = setTimeout(() => setShopHover(false), 400); };

  const DEFAULT_CATS = [
    { title:"TOP",    catFilter:"Top",    items:["Training Tee","Zip-Up Hoodie","Base Layer"] },
    { title:"BOTTOM", catFilter:"Bottom", items:["Running Pant","Track Pant","Training Short"] },
  ];
  const cats = navCats || DEFAULT_CATS;

  const DEFAULT_MAIN_MENU = [
    { id:"shop",  label:"Shop",         type:"shop",  visible:true },
    { id:"new",   label:"New In",       type:"new",   visible:true },
    { id:"best",  label:"Best Sellers", type:"best",  visible:true },
    { id:"about", label:"About",        type:"about", visible:true },
    { id:"board", label:"고객센터",      type:"board", visible:true },
  ];
  const menuItems = (mainMenu || DEFAULT_MAIN_MENU).filter(m => m.visible !== false);

  const getMenuAction = (item) => {
    switch (item.type) {
      case "shop":     return () => onGoShop("All");
      case "shop_all": return () => onGoShop("All");
      case "new":      return () => onGoShop("new");
      case "best":     return () => onGoShop("best");
      case "about":    return onGoAbout;
      case "board":    return onGoBoard;
      default:         return () => {};
    }
  };

  const headerBg     = showBg ? "rgba(248,248,246,.96)" : "transparent";
  const headerBorder = showBg ? `1px solid ${C.border}` : "1px solid transparent";
  const textColor    = C.ink;

  const displayName = profile?.name || user?.user_metadata?.display_name || profile?.username || user?.email?.split("@")[0] || "MY";
  const socialProvider = user?.app_metadata?.provider === 'kakao' ? 'kakao'
    : (user?.user_metadata?.provider === 'naver' || user?.app_metadata?.provider === 'naver') ? 'naver'
    : null;

  return (
    <header style={{ position:"fixed", top:0, left:0, right:0, zIndex:1000, transition:"all .4s" }}>
      {/* ── 이벤트 배너 ── */}
      {eventBannerVisible && (
        <div style={{ height:36, background:eventBanner?.bgColor || '#1A1A1A', display:'flex', alignItems:'center', justifyContent:'center', position:'relative', paddingInline:40 }}>
          {eventBanner?.link ? (
            <a href={eventBanner.link} style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, letterSpacing:2, color:eventBanner?.textColor || '#F2F1ED', textDecoration:'none' }}>
              {eventBanner.text}
            </a>
          ) : (
            <span style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, letterSpacing:2, color:eventBanner?.textColor || '#F2F1ED' }}>
              {eventBanner?.text}
            </span>
          )}
          <button onClick={onDismissEventBanner} style={{ position:'absolute', right:16, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:eventBanner?.textColor || '#F2F1ED', fontSize:16, lineHeight:1, opacity:.7 }}>
            ×
          </button>
        </div>
      )}
      <div style={{ background:headerBg, borderBottom:headerBorder, backdropFilter:showBg?"blur(14px)":"none" }}>
      <div style={{ padding:"0 24px", height:60, display:"flex", alignItems:"center", justifyContent:"space-between" }}>

        {/* LOGO + NAV */}
        <div style={{ display:"flex", alignItems:"center", gap:40 }}>
          <div onClick={onGoHome} style={{ cursor:"pointer" }}>
            <span style={{ fontFamily:"'DM Serif Display',serif", fontSize:24, letterSpacing:5, color:textColor }}>UNDERLOOKED</span>
          </div>
          <nav className="nav-desktop" style={{ display:"flex", gap:32, alignItems:"center" }}>
            {menuItems.map(item => (
              item.type === "shop" ? (
                <div key={item.id} className="shop-wrap" onMouseEnter={handleShopEnter} onMouseLeave={handleShopLeave}>
                  <button className="nt" style={{ color:textColor }}>{item.label}</button>
                  {shopHover && (
                    <>
                      <div className="dropdown-bridge" onMouseEnter={handleShopEnter} onMouseLeave={handleShopLeave} />
                      <div className="dropdown" onMouseEnter={handleShopEnter} onMouseLeave={handleShopLeave}>
                        {cats.map(({ title, catFilter, items: subItems }) => (
                          <div key={title}>
                            <p className="drop-col-title">{title}</p>
                            {subItems.map(si => {
                              const label  = typeof si === "string" ? si : si.label;
                              const filter = typeof si === "string" ? catFilter : si.filter;
                              return (
                                <button key={label} className="drop-item"
                                  style={{ background:"none", border:"none", cursor:"pointer", width:"100%", textAlign:"left", padding:"6px 0" }}
                                  onClick={() => { onGoShop(filter); setShopHover(false); setMenuOpen(false); }}>
                                  {label}
                                </button>
                              );
                            })}
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <button key={item.id} className="nt" style={{ color:textColor }} onClick={getMenuAction(item)}>
                  {item.label}
                </button>
              )
            ))}
          </nav>
        </div>

        {/* RIGHT ICONS */}
        <div style={{ display:"flex", alignItems:"center", gap:20 }}>

          {/* USER */}
          <div ref={userMenuRef} style={{ position:"relative" }}>
            <button
              onClick={() => user ? setUserMenuOpen(o => !o) : onOpenAuth()}
              style={{ background:"none", border:"none", cursor:"pointer", display:"flex", alignItems:"center", gap:6, padding:"4px 0" }}
              title={user ? displayName : "로그인"}
            >
              {user ? (
                <span style={{
                  fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:11,
                  letterSpacing:2.5, color:textColor, textTransform:"uppercase",
                }}>MY</span>
              ) : (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={textColor} strokeWidth="1.5">
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
                </svg>
              )}
            </button>

            {/* User dropdown */}
            {userMenuOpen && user && (
              <div style={{
                position:"absolute", top:"calc(100% + 10px)", right:0,
                background:C.bg, border:`1px solid ${C.border}`, minWidth:160,
                boxShadow:"0 8px 24px rgba(0,0,0,.08)", animation:"fadeIn .15s ease", zIndex:2100,
              }}>
                <div style={{ padding:"14px 16px", borderBottom:`1px solid ${C.border}` }}>
                  <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:11, letterSpacing:1 }}>{displayName}</p>
                  <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:10, color:C.muted, marginTop:2 }}>
                    {socialProvider === 'naver' ? '네이버 계정'
                      : socialProvider === 'kakao' ? '카카오 계정'
                      : profile?.username ? `@${profile.username}` : user.email}
                  </p>
                </div>
                <button
                  onClick={() => { setUserMenuOpen(false); onGoMyPage(); }}
                  style={{ width:"100%", padding:"12px 16px", background:"none", border:"none", cursor:"pointer", textAlign:"left", fontFamily:"'Pretendard',sans-serif", fontSize:11, letterSpacing:1, color:C.ink, transition:"background .15s", borderBottom:`1px solid ${C.border}` }}
                  onMouseEnter={e => e.currentTarget.style.background = C.bg2}
                  onMouseLeave={e => e.currentTarget.style.background = "none"}
                >마이페이지</button>
                <button
                  onClick={() => { signOut(); setUserMenuOpen(false); }}
                  style={{ width:"100%", padding:"12px 16px", background:"none", border:"none", cursor:"pointer", textAlign:"left", fontFamily:"'Pretendard',sans-serif", fontSize:11, letterSpacing:1, color:C.ink, transition:"background .15s" }}
                  onMouseEnter={e => e.currentTarget.style.background = C.bg2}
                  onMouseLeave={e => e.currentTarget.style.background = "none"}
                >로그아웃</button>
              </div>
            )}
          </div>

          {/* CART */}
          <button
            onClick={onOpenCart}
            style={{ position:"relative", background:"none", border:"none", cursor:"pointer", display:"flex", alignItems:"center", padding:"4px 0" }}
            title="장바구니"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={textColor} strokeWidth="1.5">
              <path d="M6 2 3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/>
              <path d="M16 10a4 4 0 01-8 0"/>
            </svg>
            {count > 0 && (
              <span style={{
                position:"absolute", top:-4, right:-6, minWidth:16, height:16,
                background:C.accent, color:"#fff", borderRadius:"50%",
                fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9,
                display:"flex", alignItems:"center", justifyContent:"center", padding:"0 3px",
              }}>{count}</span>
            )}
          </button>

          {/* HAMBURGER */}
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}
            style={{ display:"none", flexDirection:"column", gap:5, background:"none", border:"none", cursor:"pointer" }}>
            {[0,1,2].map(i => (
              <span key={i} style={{
                display:"block", width:22, height:1, background:textColor, transition:"transform .3s, opacity .3s",
                transform: menuOpen && i===0 ? "rotate(45deg) translate(4px,4px)" : menuOpen && i===2 ? "rotate(-45deg) translate(4px,-4px)" : "none",
                opacity: menuOpen && i===1 ? 0 : 1,
              }} />
            ))}
          </button>
        </div>
      </div>
      </div>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div style={{ background:C.bg, borderTop:`1px solid ${C.border}`, padding:"24px 48px 36px" }}>
          {menuItems.map(item => (
            <div key={item.id} onClick={() => { getMenuAction(item)(); setMenuOpen(false); }}
              style={{ padding:"10px 0", borderBottom:`1px solid ${C.border}`, cursor:"pointer" }}>
              <span style={{ fontFamily:"'DM Serif Display',serif", fontSize:24, letterSpacing:1 }}>{item.label}</span>
            </div>
          ))}
          <div style={{ paddingTop:20, display:"flex", gap:16 }}>
            {user ? (
              <button onClick={() => { signOut(); setMenuOpen(false); }} style={{ background:"none", border:`1px solid ${C.border}`, padding:"8px 16px", cursor:"pointer", fontFamily:"'Pretendard',sans-serif", fontSize:10, letterSpacing:2 }}>로그아웃</button>
            ) : (
              <button onClick={() => { onOpenAuth(); setMenuOpen(false); }} style={{ background:C.ink, color:C.bg, border:"none", padding:"8px 16px", cursor:"pointer", fontFamily:"'Pretendard',sans-serif", fontSize:10, letterSpacing:2 }}>로그인 / 회원가입</button>
            )}
            <button onClick={() => { onOpenCart(); setMenuOpen(false); }} style={{ position:"relative", background:"none", border:`1px solid ${C.border}`, padding:"8px 16px", cursor:"pointer", fontFamily:"'Pretendard',sans-serif", fontSize:10, letterSpacing:2 }}>
              장바구니{count > 0 ? ` (${count})` : ""}
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
